import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { type DistanceUnit } from '../domain/DistanceUnit'
import { type LanePreference } from '../domain/LanePreferences'
import { ProposalRepository } from '../infra/ProposalRepository'

export type UpdateLaneProposalFactoryDependencies = {
  repository: ProposalRepository
}

export type UpdateLaneProposalParams = {
  updateParams: {
    capacity: number
    flatRate: number
    laneProposalId: number
    laneId: number
    perDistanceRate: number
    rfpId: string
    distanceUnit: DistanceUnit
    preference?: LanePreference
  }
  config: { signal: AbortSignal }
}

export function updateLaneProposalFactory({ repository }: UpdateLaneProposalFactoryDependencies) {
  return function updateLane({ updateParams, config }: UpdateLaneProposalParams) {
    return repository.updateLaneProposal(updateParams, config)
  }
}

export function updateLaneProposal(params: UpdateLaneProposalParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ProposalRepository({ httpClient })
  const updateLane = updateLaneProposalFactory({ repository })
  return updateLane(params)
}
